import { useCallback } from 'react';

import { ConfirmationDialog } from '@modules/_shared/components/ConfirmationDialog';
import { useAwaitableConfirm } from '@modules/_shared/hooks/useAwaitableConfirm';
import { useLocale } from '@shared/hooks/locale';

export const useConfirmAgentChange = () => {
  const { t } = useLocale();
  const { open, confirm: requestConfirm, settle } = useAwaitableConfirm();

  const confirm = useCallback(
    () => requestConfirm(undefined),
    [requestConfirm],
  );

  const dialog = (
    <ConfirmationDialog
      open={open}
      onClose={() => settle(false)}
      onConfirm={() => settle(true)}
      title={t('Change the listing agent?')}
      message={t(
        'Depending on your team settings, you may lose access to this listing once the agent is changed.',
      )}
      confirmText={t('Change agent')}
    />
  );

  return { confirm, dialog };
};
